module.exports = __webpack_public_path__ + "static/media/filter-button.e754f912.svg";